module.exports = "<span>\r\n    Грешени данни\r\n</span>"